import { usuarioServicoFinanceiroTipo } from "../../../context/servicoFinanceiroCliente";
import { DateFormatterMonthName } from "../../../functions/DateFormatter";
import { guardarDadosUsuario, guardarDadosUsuario2, obterDadosUsuario2, obterServiçosFinanceiros } from "../../../services/cookies";
import { obterPosicaoConsolidade } from "../../../services/dashboard";
import {
    obterComposicaoCarteira,
    obterHistoricoFechamentoMensal,
    obterUltimoFechamento,
} from "../../../services/fechamento";
import { renovacaoToken } from "../../../services/usuario";
import { getClienteServicosFinanceiros } from "../../../services/cliente";
import { DadosPosicao } from "./Home";
import React from "react";
import { ativoFinanceiro } from "../Ativos/Ativos";
import { randomColor } from "../Ativos/functions";


async function renovarTokenOuDesconectar(
    onDesconectar: () => void
): Promise<string | null> {
    const { token, tokenRenovacao, email, id } = obterDadosUsuario2();

    try {
        const res = await renovacaoToken(token, tokenRenovacao);

        guardarDadosUsuario(
            res.data.camposAdicionais.tokenAcesso,
            res.data.camposAdicionais.tokenRenovacao,
            email,
            id
        );
        guardarDadosUsuario2(
            res.data.camposAdicionais.tokenAcesso,
            res.data.camposAdicionais.tokenRenovacao,
            email,
            id
        );

        return res.data.camposAdicionais.tokenAcesso;
    } catch (error) {
        onDesconectar();
        return null;
    }
}

export async function handlePosicaoConsolidada(
    setLoadingPosicao: (value: React.SetStateAction<boolean>) => void,
    setErrorPosicao: (value: React.SetStateAction<boolean>) => void,
    setDadosPosicao: (value: React.SetStateAction<DadosPosicao>) => void,
    usuarioServicoFinanceiro: usuarioServicoFinanceiroTipo,
    token: string,
    idCliente?: string,
) {
    try {
        setLoadingPosicao(true);
        setErrorPosicao(false);
        const idUsuario = obterDadosUsuario2().id;
        const res = await obterPosicaoConsolidade(idCliente || idUsuario, usuarioServicoFinanceiro.idServicoFinanceiro, token);
        setDadosPosicao(res.data.resultado.dadosHomeCliente);
    } catch (error) {
        console.error("Erro na posição consolidada:", error);
        setErrorPosicao(true);
    } finally {
        setLoadingPosicao(false);
    }
}

export async function handleHistoricoFechamento(
    setLoadingGrafico: (value: React.SetStateAction<boolean>) => void,
    setErrorGrafico: (value: React.SetStateAction<boolean>) => void,
    dataInicial: string,
    dataFinal: string,
    setModalDesconectar: React.Dispatch<React.SetStateAction<boolean>>,
    setRendimentosDia: (value: React.SetStateAction<number[]>) => void,
    setValoresTotais: (value: React.SetStateAction<number[]>) => void,
    setLabels: (value: React.SetStateAction<string[]>) => void,
    setValoresAcumulados: (value: React.SetStateAction<number[]>) => void,
    usuarioServicoFinanceiro: usuarioServicoFinanceiroTipo,
    setLoadingPosicao: (value: React.SetStateAction<boolean>) => void,
    setErrorPosicao: (value: React.SetStateAction<boolean>) => void,
    setDadosPosicao: (value: React.SetStateAction<DadosPosicao>) => void,
    setLabelsMoeda: React.Dispatch<React.SetStateAction<string[]>>,
    setPorcentagem: React.Dispatch<React.SetStateAction<number[]>>,
    setValorUnitario: React.Dispatch<React.SetStateAction<number[]>>,
    setValorTotal: React.Dispatch<React.SetStateAction<number[]>>,
    colorArray: string[],
    setColorArray: React.Dispatch<React.SetStateAction<string[]>>,
    setValoresTotaisPrivate: (value: React.SetStateAction<number[]>) => void,
    idCliente?: string,
    tokenInicial?: string,
) {
    setLoadingGrafico(true);
    setErrorGrafico(false);

    const serviçosFinanceiros = obterServiçosFinanceiros();
    const dataInicialZerada = new Date(new Date(dataInicial).setHours(0)).toISOString();
    let token = tokenInicial || obterDadosUsuario2().token;

    try {
        const res = await obterHistoricoFechamentoMensal(dataInicialZerada, dataFinal, token, usuarioServicoFinanceiro.id);
        const dadosProcessados = processarFechamentosMensais(res.data.resultado.fechamentos);

        pegaDadosGrafico(dadosProcessados, setRendimentosDia, setValoresTotais, setLabels, setValoresAcumulados, setValoresTotaisPrivate);

        await Promise.all([
            exibirAtivosNaHome(
                setLabelsMoeda,
                setPorcentagem,
                setValorUnitario,
                setValorTotal,
                setLoadingGrafico,
                setLoadingGrafico,
                colorArray,
                setColorArray,
                usuarioServicoFinanceiro,
                token,
                idCliente
            ),
            handlePosicaoConsolidada(
                setLoadingPosicao,
                setErrorPosicao,
                setDadosPosicao,
                usuarioServicoFinanceiro.idServicoFinanceiro === 0 ? serviçosFinanceiros[0] : usuarioServicoFinanceiro,
                token,
                idCliente
            )
        ]);
    } catch (err: any) {
        if (err?.response?.status === 401) {
            const novoToken = await renovarTokenOuDesconectar(() => setModalDesconectar(true));
            if (novoToken) {
                // Tentar novamente com novo token
                await handleHistoricoFechamento(
                    setLoadingGrafico,
                    setErrorGrafico,
                    dataInicial,
                    dataFinal,
                    setModalDesconectar,
                    setRendimentosDia,
                    setValoresTotais,
                    setLabels,
                    setValoresAcumulados,
                    usuarioServicoFinanceiro,
                    setLoadingPosicao,
                    setErrorPosicao,
                    setDadosPosicao,
                    setLabelsMoeda,
                    setPorcentagem,
                    setValorUnitario,
                    setValorTotal,
                    colorArray,
                    setColorArray,
                    setValoresTotaisPrivate,
                    idCliente,
                    novoToken
                );
            }
        } else {
            console.error("Erro ao carregar histórico:", err);
            setErrorGrafico(true);
        }
    } finally {
        setLoadingGrafico(false);
    }
}

function processarFechamentosMensais(fechamentos: any[]): any[] {
    const agregadosPorMes = fechamentos.reduce((acumulador: any, item: any) => {
        const data = new Date(item.data);
        const anoMes = `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, '0')}`;
        const dia = data.getDate();

        if (!acumulador[anoMes]) acumulador[anoMes] = [];
        acumulador[anoMes].push({ ...item, dia });

        return acumulador;
    }, {});

    return Object.entries(agregadosPorMes).map(([mesAno, items]: any) => {
        items.sort((a: any, b: any) => a.dia - b.dia);

        const itemEscolhido = items.find((item: any) => [5, 6, 7].includes(item.dia));
        return itemEscolhido ? {
            data: mesAno,
            valorTotalDolar: itemEscolhido.valorTotalDolar,
            valorTotalReal: itemEscolhido.valorTotalReal,
            rendimentoDiario: itemEscolhido.rendimentoDiario,
            valorCota: itemEscolhido.valorCota
        } : null;
    }).filter(Boolean);
}


export const pegaDadosGrafico = (
    arrayFechamentos: any[],
    setRendimentosDia: (value: React.SetStateAction<number[]>) => void,
    setValoresTotais: (value: React.SetStateAction<number[]>) => void,
    setLabels: (value: React.SetStateAction<string[]>) => void,
    setValoresAcumulados: (value: React.SetStateAction<number[]>) => void,
    setValoresTotaisPrivate: (value: React.SetStateAction<number[]>) => void,

) => {
    let rendimentoParciais: number[] = []
    let valoresParciais: number[] = []
    let valoresParciaisPrivate: number[] = []
    let valoresAcumuladosParciais: number[] = []
    let labelsParciais: string[] = []

    rendimentoParciais = []
    valoresParciais = []
    valoresParciaisPrivate = []
    valoresAcumuladosParciais = []
    labelsParciais = []

    // TODO: REFACTOR
    arrayFechamentos.forEach((fechamentoDiario, index, array: any) => {
        rendimentoParciais = [...rendimentoParciais, ((fechamentoDiario.rendimentoDiario / array[0].rendimentoDiario) - 1) * 100]
        labelsParciais = [...labelsParciais, DateFormatterMonthName(fechamentoDiario.data)]
        index === 0 ? valoresParciais = [10.11] : valoresParciais = [...valoresParciais, (((fechamentoDiario.valorCota / array[index - 1].valorCota) - 1) * 100)]
        index === 0 ? valoresParciaisPrivate = [0] : valoresParciaisPrivate = [...valoresParciaisPrivate, (((fechamentoDiario.rendimentoDiario / array[index - 1].rendimentoDiario) - 1) * 100)]
        valoresAcumuladosParciais = [...valoresAcumuladosParciais, ((fechamentoDiario.valorCota / 1101.10) - 1) * 100]
    })

    setValoresTotaisPrivate(valoresParciaisPrivate);
    setRendimentosDia(rendimentoParciais);
    setValoresTotais(valoresParciais);
    setValoresAcumulados(valoresAcumuladosParciais);
    setLabels(labelsParciais);
}

export interface servicoFinanceiro {
    id: string,
    idServicoFinanceiro: number,
    servicoFinanceiro: string,
}

export const exibirAtivosNaHome = async (
    setLabelsMoeda: React.Dispatch<React.SetStateAction<string[]>>,
    setPorcentagem: React.Dispatch<React.SetStateAction<number[]>>,
    setValorUnitario: React.Dispatch<React.SetStateAction<number[]>>,
    setValorTotal: React.Dispatch<React.SetStateAction<number[]>>,
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    setErroPage: React.Dispatch<React.SetStateAction<boolean>>,
    colorArray: string[],
    setColorArray: React.Dispatch<React.SetStateAction<string[]>>,
    usuarioServicoFinanceiro: usuarioServicoFinanceiroTipo,
    token: string,
    idCliente?: string,
) => {
    const request = idCliente
        ? obterUltimoFechamento(
            token,
            usuarioServicoFinanceiro.idServicoFinanceiro,
            idCliente
        )
        : obterComposicaoCarteira(
            token,
            usuarioServicoFinanceiro.idServicoFinanceiro
        );

    await request
        .then((res) => {
            const ativosFinanceiros = idCliente
                ? res.data.resultado.fechamento.ativosFinanceiros
                : res.data.resultado.ativos;

            handleDataAndLabels(
                ativosFinanceiros,
                setLabelsMoeda,
                setPorcentagem,
                setValorUnitario,
                setValorTotal,
                colorArray,
                setColorArray
            );
            setErroPage(false);
        })
        .catch(async (e) => {
            setErroPage(true);
        }).finally(() => setLoading(false));
};

function handleDataAndLabels(
    ativosFinanceiros: ativoFinanceiro[],
    setLabels: React.Dispatch<React.SetStateAction<string[]>>,
    setPorcentagem: React.Dispatch<React.SetStateAction<number[]>>,
    setValorUnitario: React.Dispatch<React.SetStateAction<number[]>>,
    setValorTotal: React.Dispatch<React.SetStateAction<number[]>>,
    colorArray: string[],
    setColorArray: React.Dispatch<React.SetStateAction<string[]>>
) {
    let labels: string[] = [];
    let porcentagem: number[] = [];

    ativosFinanceiros
        .filter((item) => item.porcentagemDoAtivoNaCarteira >= 1)
        .forEach(ativoFinanceiro => {
            labels.push(ativoFinanceiro.sigla + ": " + ativoFinanceiro.porcentagemDoAtivoNaCarteira.toFixed(2) + "%");
            porcentagem.push(ativoFinanceiro.porcentagemDoAtivoNaCarteira)
        }
        )

    setLabels(labels);
    setPorcentagem(porcentagem);
    setValorUnitario([]);
    setValorTotal([]);
    randomColor(porcentagem, colorArray, setColorArray);
}

export const obterServicosFinanceirosCliente = async (
    idCredenciais: string,
    setListaServicosFinanceiros: React.Dispatch<servicoFinanceiro[]>,
    setErro: React.Dispatch<boolean>,
    setDesconectar: React.Dispatch<React.SetStateAction<boolean>>,
    setServicoFinanceiroCliente: React.Dispatch<usuarioServicoFinanceiroTipo>,
    setIdServicoFinanceiroCliente: React.Dispatch<number>,
    setLoadingGrafico: React.Dispatch<React.SetStateAction<boolean>>,
    setErrorGrafico: React.Dispatch<React.SetStateAction<boolean>>,
    dataInicial: string,
    dataFinal: string,
    setRendimentosDia: React.Dispatch<React.SetStateAction<number[]>>,
    setValoresTotais: React.Dispatch<React.SetStateAction<number[]>>,
    setLabels: React.Dispatch<React.SetStateAction<string[]>>,
    setValoresAcumulados: React.Dispatch<React.SetStateAction<number[]>>,
    usuarioServicoFinanceiro: usuarioServicoFinanceiroTipo,
    setLoadingPosicao: React.Dispatch<React.SetStateAction<boolean>>,
    setErrorPosicao: React.Dispatch<React.SetStateAction<boolean>>,
    setDadosPosicao: React.Dispatch<React.SetStateAction<DadosPosicao>>,
    setLabelsMoeda: React.Dispatch<React.SetStateAction<string[]>>,
    setPorcentagem: React.Dispatch<React.SetStateAction<number[]>>,
    setValorUnitario: React.Dispatch<React.SetStateAction<number[]>>,
    setValorTotal: React.Dispatch<React.SetStateAction<number[]>>,
    colorArray: string[],
    setColorArray: React.Dispatch<React.SetStateAction<string[]>>,
    setValoresTotaisPrivate: React.Dispatch<React.SetStateAction<number[]>>,
    idCliente?: string
) => {
    try {
        const { token } = obterDadosUsuario2();

        await carregarServicosEFazerChamada(
            token,
            idCredenciais,
            setListaServicosFinanceiros,
            setServicoFinanceiroCliente,
            setIdServicoFinanceiroCliente,
            setErro,
            setDesconectar,
            setLoadingGrafico,
            setErrorGrafico,
            dataInicial,
            dataFinal,
            setRendimentosDia,
            setValoresTotais,
            setLabels,
            setValoresAcumulados,
            usuarioServicoFinanceiro,
            setLoadingPosicao,
            setErrorPosicao,
            setDadosPosicao,
            setLabelsMoeda,
            setPorcentagem,
            setValorUnitario,
            setValorTotal,
            colorArray,
            setColorArray,
            setValoresTotaisPrivate,
            idCliente
        );

    } catch (err: any) {
        if (err?.response?.status === 401) {
            const novoToken = await renovarTokenOuDesconectar(() => setDesconectar(true));

            if (novoToken) {
                await carregarServicosEFazerChamada(
                    novoToken,
                    idCredenciais,
                    setListaServicosFinanceiros,
                    setServicoFinanceiroCliente,
                    setIdServicoFinanceiroCliente,
                    setErro,
                    setDesconectar,
                    setLoadingGrafico,
                    setErrorGrafico,
                    dataInicial,
                    dataFinal,
                    setRendimentosDia,
                    setValoresTotais,
                    setLabels,
                    setValoresAcumulados,
                    usuarioServicoFinanceiro,
                    setLoadingPosicao,
                    setErrorPosicao,
                    setDadosPosicao,
                    setLabelsMoeda,
                    setPorcentagem,
                    setValorUnitario,
                    setValorTotal,
                    colorArray,
                    setColorArray,
                    setValoresTotaisPrivate,
                    idCliente
                );
            }
        } else {
            console.error("Erro ao obter serviços financeiros:", err);
            setErro(true);
        }
    }
};


async function carregarServicosEFazerChamada(
    token: string,
    idCredenciais: string,
    setListaServicosFinanceiros: React.Dispatch<servicoFinanceiro[]>,
    setServicoFinanceiroCliente: React.Dispatch<usuarioServicoFinanceiroTipo>,
    setIdServicoFinanceiroCliente: React.Dispatch<number>,
    setErro: React.Dispatch<boolean>,
    setDesconectar: React.Dispatch<React.SetStateAction<boolean>>,
    setLoadingGrafico: React.Dispatch<React.SetStateAction<boolean>>,
    setErrorGrafico: React.Dispatch<React.SetStateAction<boolean>>,
    dataInicial: string,
    dataFinal: string,
    setRendimentosDia: React.Dispatch<React.SetStateAction<number[]>>,
    setValoresTotais: React.Dispatch<React.SetStateAction<number[]>>,
    setLabels: React.Dispatch<React.SetStateAction<string[]>>,
    setValoresAcumulados: React.Dispatch<React.SetStateAction<number[]>>,
    usuarioServicoFinanceiro: usuarioServicoFinanceiroTipo,
    setLoadingPosicao: React.Dispatch<React.SetStateAction<boolean>>,
    setErrorPosicao: React.Dispatch<React.SetStateAction<boolean>>,
    setDadosPosicao: React.Dispatch<React.SetStateAction<DadosPosicao>>,
    setLabelsMoeda: React.Dispatch<React.SetStateAction<string[]>>,
    setPorcentagem: React.Dispatch<React.SetStateAction<number[]>>,
    setValorUnitario: React.Dispatch<React.SetStateAction<number[]>>,
    setValorTotal: React.Dispatch<React.SetStateAction<number[]>>,
    colorArray: string[],
    setColorArray: React.Dispatch<React.SetStateAction<string[]>>,
    setValoresTotaisPrivate: React.Dispatch<React.SetStateAction<number[]>>,
    idCliente?: string
) {
    try {
        const res = await getClienteServicosFinanceiros(token, idCredenciais);
        const cliente = res.data.resultado.clientes[0];

        setListaServicosFinanceiros(res.data.resultado.clientes);
        setServicoFinanceiroCliente(cliente);
        setIdServicoFinanceiroCliente(cliente.idServicoFinanceiro);

        await handleHistoricoFechamento(
            setLoadingGrafico,
            setErrorGrafico,
            dataInicial,
            dataFinal,
            setDesconectar,
            setRendimentosDia,
            setValoresTotais,
            setLabels,
            setValoresAcumulados,
            cliente,
            setLoadingPosicao,
            setErrorPosicao,
            setDadosPosicao,
            setLabelsMoeda,
            setPorcentagem,
            setValorUnitario,
            setValorTotal,
            colorArray,
            setColorArray,
            setValoresTotaisPrivate,
            idCliente,
            token
        );
    } catch (error) {
        throw error;
    }
}
